import { DocumentArrowUpIcon } from "@heroicons/react/24/outline";

const FileUploadCard = ({
  triggerFileInput,
  handleDirectFileSelect,
}: {
  triggerFileInput: () => void;
  handleDirectFileSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <div className="mb-4 p-4 bg-gray-50 border border-gray-200 rounded-lg">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <DocumentArrowUpIcon className="h-5 w-5 text-gray-500 mr-2" />
          <div>
            <p className="text-sm font-medium text-gray-900">
              Import load data from file
            </p>
            <p className="text-xs text-gray-600">
              Upload CSV, Excel, or PDF to auto-populate form
            </p>
          </div>
        </div>
        <button
          onClick={triggerFileInput}
          className="text-sm text-gray-700 hover:text-gray-900 font-medium border border-gray-300 px-3 py-1 rounded-md hover:bg-gray-100 transition-colors"
        >
          Upload File
        </button>
      </div>

      {/* Hidden file input */}
      <input
        id="hidden-file-input"
        type="file"
        accept=".csv,.xlsx,.xls,.pdf"
        onChange={handleDirectFileSelect}
        style={{ display: "none" }}
      />
    </div>
  );
};

export default FileUploadCard;
